import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import getShipments from "./functions/getShipments";
import FilterExternalLetters from "./FilterExternalLetters";
import PaginateCard from "../../../components/PaginateCard";
import Laoding from "../../../components/Loading";
import { IoIosInformationCircle } from "react-icons/io";
import dateTimeToJalali from "../../../function/jalali/dateTimetoJalali";
import style from "./ExternalShipments.module.css";
import DetailModal from "./detail/DetailModal";
import { Link } from "react-router-dom";

function ExternalShipments() {
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [count, setCount] = useState(0);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [parts, setParts] = useState([]);

  const [filter, setFilter] = useState({
    numberitems: 10,
    numberpage: 1,
  });

  useEffect(() => {
    getShipments({
      loading: setLoading,
      set: (array, count) => {
        setCount(count);
        setPosts(array);
      },
      values: filter,
    });
  }, [filter.numberpage, filter.numberitems]);

  return (
    <section>
      <FilterExternalLetters state={{ filter: filter, setFilter: setFilter }} />
      <div className="w-100 px-1 overflow-x-auto">
        <Table bordered={true} striped={true} className="mt-4">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>بارنامه</th>
              <th>سرویس دهنده</th>
              <th>مبدا</th>
              <th>مقصد</th>
              <th>مبلغ فاکتور</th>
              <th>جزئیات</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {loading === true && (
              <tr>
                <td colSpan={8}>
                  <Laoding />
                </td>
              </tr>
            )}

            {loading === false &&
              posts.map((item, idx) => (
                <tr key={item.id} className="align-middle">
                  <td>
                    {idx + filter.numberitems * (filter.numberpage - 1) + 1}
                  </td>
                  <td>
                    <Link
                      to={`/factor/${item.numberParcel}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.numberParcel}
                    </Link>
                  </td>
                  <td>{item.company?.name}</td>
                  <td>
                    {"ایران " +
                      item.source.province.faName +
                      " " +
                      item.source.city.faName +
                      ", " +
                      (item.source.compony
                        ? item.source.compony
                        : item.source.name + " " + item.source.family)}
                  </td>
                  <td>
                    {item.destination.country.faName +
                      " " +
                      item.destination.address_external.fa_city_name +
                      ", " +
                      (item.destination.compony
                        ? item.destination.compony
                        : item.destination.name +
                          " " +
                          item.destination.family)}
                  </td>
                  <td>{item.realPayable}</td>
                  <td>
                    <button
                      className={style.btn}
                      onClick={() => {
                        setShowDetailModal(true);
                        setParts(item.external_orders);
                      }}
                    >
                      <IoIosInformationCircle />
                    </button>
                  </td>
                  <td>{dateTimeToJalali(item.created_at).full}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <PaginateCard
        numberPage={filter.numberpage}
        numberItems={filter.numberitems}
        count={count}
        onIndexChoose={number =>
          setFilter(cur => ({ ...cur, numberpage: number }))
        }
      />

      {showDetailModal === true && (
        <DetailModal close={() => setShowDetailModal(false)} parts={parts} />
      )}
    </section>
  );
}

export default ExternalShipments;
